<div class="padding">
  <div>
    <div class="header">{{ 'configuration_update' | translate }}</div>
  </div>
  <div>
    <mat-icon class="close-icon" (click)="close()">close</mat-icon>
  </div>

  <form (ngSubmit)="update()" #form="ngForm" novalidate>
    <div class="flexColumn">

      <mat-form-field appearance="fill">
        <mat-label>{{ 'configuration_key' | translate }}</mat-label>
        <input type="text" name="key" matInput #key="ngModel" placeholder="key" required
          [ngModel]="configuration.key" disabled="true">
      </mat-form-field>

      <mat-form-field appearance="fill">
        <mat-label>{{ 'configuration_value' | translate }}</mat-label>
        <textarea type="text" name="value" rows="4" matInput #value="ngModel" placeholder="Value" required
          [(ngModel)]="configuration.value" pattern="^[\sa-zA-Z0-9\|\;\:\@\#\.\(\)\(/)_\-]+$" minlength="1" maxlength="250">
        </textarea>
        <mat-hint>Minimum characters 1, {{configuration.value == null ? 0 : configuration.value?.length}}/250
          Characters</mat-hint>
        <mat-error *ngIf="value.hasError('required')">{{ 'configuration_required' | translate }}</mat-error>
        <mat-error *ngIf="value.hasError('minlength')">{{ 'configuration_minLength' | translate }}</mat-error>
        <mat-error *ngIf="value.hasError('pattern')">{{ 'configuration_allowed' | translate }}</mat-error>
      </mat-form-field>

      <div class="saveRow">
        <a type="button" mat-raised-button (click)="cancel()">{{ 'cancel' | translate }}</a>
        <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid">{{ 'save' | translate
          }}</button>
      </div>

    </div>
  </form>

</div>